import { layout } from '../../App.routing'

export const worldSegment = layout.component({
    type: 'uniform',
    feature: 'world-collection',
    props: {
        section: 'news',
        verticalSpacing: 'xl',
        cardOrientation: { type: 'Landscape-Portrait' },
        cardLayout: [
            ['teaserWithBackground'],
            ['teaserWithBackground'],
            ['teaserWithBackground'],
            {
                type: 'november',
                listLength: 5,
                hasTimestamp: true,
            },
        ],

        sectionHeader: {
            heading: 'World',
            headingUrl: '/news/world',
            section: 'news',
        },
        dataDefinitionArgs: {
            type: 'curation',
            name: 'world',
            offset: 0,
            pageSize: 8,
        },
    },
})
